import React from 'react';
import SectionHeading from './SectionHeading';

const Skills = function({ lang, isDark, sections, skills }) {
  return (
    <section id="skills" className="mb-8" aria-labelledby="skills-heading">
      <div className="section-card">
        <SectionHeading id="skills-heading" isDark={isDark}>{sections.analytics}</SectionHeading>
        <div className="space-y-6">
          {skills.map((skill, i) => (
            <div key={i} className="flex gap-3">
              <div className={`w-1 shrink-0 rounded-full bg-gradient-to-b ${skill.color || 'from-blue-400 to-cyan-400'}`} />
              <div className="flex flex-col gap-1">
                <span className={`text-[11px] uppercase tracking-widest font-semibold ${isDark ? 'text-slate-500' : 'text-slate-400'}`}>
                  {skill.category?.[lang] || skill.category?.en}
                </span>
                <h3 className={`text-[15px] font-bold ${isDark ? 'text-slate-200' : 'text-slate-800'}`}>
                  {skill.name}
                </h3>
                <p className={`text-[13px] leading-relaxed font-medium ${isDark ? 'text-slate-400' : 'text-slate-600'}`}>
                  {skill.useCase?.[lang] || skill.useCase?.en}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default React.memo(Skills);
